"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateProjectionPE = exports.calculateFairPricePE = void 0;
var fair_price_shared_1 = require("./fair-price-shared");
function calculateFairPricePE(eps, growthRate, peRatio, requiredReturn, years) {
    if (years === void 0) { years = fair_price_shared_1.DCF_YEARS; }
    var futurePrice = eps * Math.pow((1 + growthRate / 100), years) * peRatio;
    return futurePrice / Math.pow((1 + requiredReturn / 100), years);
}
exports.calculateFairPricePE = calculateFairPricePE;
function calculateProjectionPE(eps, growthRate, peRatio, requiredReturn, years, totalYears) {
    if (totalYears === void 0) { totalYears = fair_price_shared_1.DCF_YEARS; }
    var futurePrice = eps * Math.pow((1 + growthRate / 100), totalYears) * peRatio;
    return futurePrice / Math.pow((1 + requiredReturn / 100), (totalYears - years));
}
exports.calculateProjectionPE = calculateProjectionPE;
//# sourceMappingURL=fair-price-pe.js.map